import { createAction, props } from '@ngrx/store';
import { PaymentTypeModel } from '../../shared/models/paymentTypeModel';

export const loadPaymentType = createAction('[PaymentType] Load PaymentType');
export const loadPaymentTypeSuccess = createAction('[PaymentType] Load PaymentType Success', props<{ data: PaymentTypeModel[] }>());
export const loadPaymentTypeFailure = createAction('[PaymentType] Load PaymentType Failure', props<{ error: any }>());